
import { IconButton, Menu, MenuItem, Typography } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons';
import React, { useState, useRef } from 'react'
import { withRouter } from 'react-router-dom';

const CMLinkDropDown = ({ name, menus, history }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const buttonRef = useRef(null);

    const handleClick = (event) => {
        setAnchorEl(buttonRef.current);
    };
    const handleClose = (path) => {
        setAnchorEl(null);
        if (path) {
            history.push(path);
        }
    };

    return (
        <div>
            <div style={{ display: "flex", gap: "5px", alignItems: "center" }} onClick={handleClick}>
                <Typography style={{
                    color: "#007bff",
                    backgroundColor: "transparent",
                    fontSize: "1.2rem",
                }}>{name}</Typography>
                <IconButton
                    ref={buttonRef}
                    aria-controls={open ? "dropdown-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    style={{ padding: "0" }}
                >
                    <ArrowDropDown />
                </IconButton>
            </div>
            <Menu
                id="dropdown-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}
                MenuListProps={{
                    "aria-labelledby": "dropdown-button",
                }}
            >
                {menus.map((menu) => (
                    <MenuItem key={menu.path} onClick={() => handleClose(menu.path)}>{menu.menuName}</MenuItem>
                ))}
            </Menu>
        </div>
    )
}

export default withRouter(CMLinkDropDown);